import { useSelector } from 'react-redux';
import { TcsmStates } from '../../../root/tcsm-model';
import { InstitutionProps } from '../models/arc-epi-props';

export function useInstitutionSetting() {

    const institutionSetting = useSelector<TcsmStates, InstitutionProps>(state => state.epiProps?.institutionSettingsState?.epiContent);

    return institutionSetting;
}